import Vue from 'vue';
import VueRouter from 'vue-router';
import StampPage from '../views/StampPage.vue';
import QrCameraPage from '../views/QrCameraPage.vue';

Vue.use(VueRouter);

const mode = 'history'; // or hash
const routes = [
  { path: '/', name: 'home', component: StampPage },
  { path: '/qrcode-reader', name: 'qrcode-reader', component: QrCameraPage },
];

const router = new VueRouter({
  mode,
  routes,
});

export default router;
